import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";
import { VKSnabbkalkylmallDTO } from "../../models/tradslag/snabbkalkylmall-models";

export class UpdateSnabbkalkylmallCommand extends BasicCommand<UpdateSnabbkalkylmallCommand> {
    readonly snabbkalkylmall: VKSnabbkalkylmallDTO;
    readonly atgardGuid: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateSnabbkalkylmallCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Snabbkalkylmall";

    get primaryKey(): IPrimaryKey<UpdateSnabbkalkylmallCommand> {
        return {
            guid: this.atgardGuid
        };
    }

    constructor(atgardGuid: string, snabbkalkylmall: VKSnabbkalkylmallDTO) {
        super(UpdateSnabbkalkylmallCommand.$type, UpdateSnabbkalkylmallCommand.$groupKey, CommandType.Replace);
        this.snabbkalkylmall = snabbkalkylmall;
        this.atgardGuid = atgardGuid;
    }
}
